export default {"src":"/_next/static/media/menu-icon-dark.640da2c3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};